import Empty from "../../Empty/Empty";
import CustomButton from "../../../../components/ui/CustomButton/CustomButton";
import plusIconWhite from "../../../../assets/images/icons/plus-white.svg";
import React from "react";
import { useTranslation } from "react-i18next";

interface SubscriptionsEmptyProps {
  onClickAddNew: () => void;
}

const SubscriptionsEmpty: React.FC<SubscriptionsEmptyProps> = ({ onClickAddNew }) => {
  const { t } = useTranslation();

  return (
    <Empty
      icon={
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="80" height="80" rx="40" fill="#FF8C42" fill-opacity="0.1" />
          <path
            d="M36.7937 24.3567C37.357 23.09 39.092 23.0283 39.772 24.1667L39.8704 24.3567L41.607 28.265C43.1235 31.6765 45.6453 34.5438 48.8354 36.4833L49.372 36.7983L52.4554 38.5317C52.7005 38.6689 52.9074 38.8653 53.0571 39.1029C53.2069 39.3406 53.2949 39.6119 53.3129 39.8923C53.331 40.1726 53.2786 40.453 53.1605 40.7079C53.0425 40.9628 52.8625 41.1841 52.637 41.3517L52.457 41.4683L49.372 43.2017C46.1177 45.0323 43.4998 47.8129 41.8687 51.1717L41.607 51.735L39.8704 55.6433C39.307 56.91 37.572 56.9717 36.892 55.8333L36.7937 55.6433L35.057 51.735C33.5406 48.3235 31.0187 45.4562 27.8287 43.5167L27.292 43.2017L24.2087 41.4683C23.9636 41.3311 23.7567 41.1347 23.6069 40.8971C23.4571 40.6594 23.3692 40.3881 23.3511 40.1077C23.3331 39.8274 23.3855 39.547 23.5035 39.2921C23.6216 39.0372 23.8015 38.8159 24.027 38.6483L24.207 38.5317L27.292 36.7983C30.5464 34.9677 33.1642 32.1871 34.7954 28.8283L35.057 28.265L36.7937 24.3567ZM38.332 29.1033C36.2587 33.77 32.8554 37.4933 28.3987 40C32.8554 42.5067 36.2587 46.23 38.332 50.8967C40.412 46.2183 43.8154 42.5033 48.2654 40C43.8087 37.4933 40.4054 33.77 38.332 29.1033ZM52.032 23.5367C52.8601 25.4156 54.2715 26.9778 56.057 27.9917C56.3237 28.1417 56.3237 28.525 56.057 28.675C54.2709 29.6897 52.8595 31.2531 52.032 33.1333C52.0004 33.2041 51.9489 33.2642 51.8838 33.3064C51.8188 33.3486 51.7429 33.371 51.6654 33.371C51.5878 33.371 51.5119 33.3486 51.4469 33.3064C51.3818 33.2642 51.3304 33.2041 51.2987 33.1333C50.471 31.2538 49.0595 29.691 47.2737 28.6767C47.2134 28.6423 47.1633 28.5926 47.1285 28.5326C47.0936 28.4726 47.0752 28.4044 47.0752 28.335C47.0752 28.2656 47.0936 28.1974 47.1285 28.1374C47.1633 28.0774 47.2134 28.0277 47.2737 27.9933C49.0601 26.9782 50.4716 25.4142 51.2987 23.5333C51.3304 23.4626 51.3818 23.4024 51.4469 23.3603C51.5119 23.3181 51.5878 23.2957 51.6654 23.2957C51.7429 23.2957 51.8188 23.3181 51.8838 23.3603C51.9489 23.4024 52.0004 23.4626 52.032 23.5333V23.5367Z"
            fill="#FF8C42"
          />
        </svg>
      }
      titleText={t("NoSubscriptionPlansYet")}
      subtitleText={t("CreateAPlanToStartOfferingCreditBundles")}
      button={
        <CustomButton
          text={t("AddSubscription")}
          type={"button"}
          typeStyle={"fill"}
          icon={plusIconWhite}
          altIcon={"add"}
          functionOnClick={onClickAddNew}
        />
      }
    />
  );
};

export default SubscriptionsEmpty;
